import FormatNumericSettings from './FormatNumericSettings';
export default FormatNumericSettings;